import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { UserActions } from '../../actions';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import DriverForm from '../../components/Drivers/Edit';

class EditDriver extends Component {
 constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      error: false
    }
  }

  gotoDrivers = () => {
    browserHistory.push('/admin/drivers');
  }
  
  saveDriver = (values) => {
    const driver = {
      name: values.name,
      phone: values.phone,
      key: values.key
    };

    this.props.dispatch(UserActions.createDriver(driver)).then((response) => {
      browserHistory.push('/admin/drivers');
    }).catch((e) => {
      this.setState({
        error: true
      })
    });
  }

  handleClose() {
    this.setState({
      error: false
    });
  }

  render() {
    const actions = [
      <FlatButton label="Ok" primary onTouchTap={this.handleClose} />
    ];
    return (
      <div className="row">
        <div className="col s12 align-center">
          <SubnavBar back={this.gotoDrivers} />
          <TitleBar title="Create Driver" />
          <div className="row">
            <div className="col s12">
              <DriverForm onSubmit={this.saveDriver} />
              <Dialog
                actions={actions}
                modal={false}
                open={this.state.error}
                onRequestClose={this.handleClose}
              >
                There was an error saving the driver.
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth
  }
}

export default connect(mapStateToProps)(EditDriver);


// WEBPACK FOOTER //
// ./src/containers/Drivers/Edit.js